import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']
  static values = {
    visible: { type: Number, default: 3 },
    interval: { type: Number, default: 3000 }
  }

  connect () {
    this.offset = 0
    this.itemCount = this.itemTargets.length

    if (this.itemCount === 0) return

    this.render()

    if (this.itemCount > this.visibleValue) {
      this.timer = window.setInterval(() => this.advance(), this.intervalValue)
      this.element.addEventListener('mouseenter', this.pause)
      this.element.addEventListener('mouseleave', this.resume)
    }
  }

  disconnect () {
    this.stopTimer()
    this.element.removeEventListener('mouseenter', this.pause)
    this.element.removeEventListener('mouseleave', this.resume)
  }

  pause = () => {
    this.stopTimer()
  }

  resume = () => {
    if (this.itemCount <= this.visibleValue) return

    this.stopTimer()
    this.timer = window.setInterval(() => this.advance(), this.intervalValue)
  }

  advance () {
    this.offset = (this.offset + 1) % this.itemCount
    this.render()
  }

  render () {
    const visible = Math.min(this.visibleValue, this.itemCount)

    this.itemTargets.forEach((element, index) => {
      let show = false

      for (let slot = 0; slot < visible; slot += 1) {
        const activeIndex = (this.offset + slot) % this.itemCount
        if (index === activeIndex) show = true
      }

      element.classList.toggle('is-visible', show)
      element.setAttribute('aria-hidden', show ? 'false' : 'true')
    })
  }

  stopTimer () {
    if (!this.timer) return

    window.clearInterval(this.timer)
    this.timer = null
  }
}
